$(document).ready(function () {
	const saveButtonActiveClass = 'active';
    if (getUrlParameter('listmode') === 'arrivals') {
        $('.flights ul.flight-tabs li').removeClass('current');
        $('.flights .flight-tab--content').removeClass('current');

        $('*[data-tab="arrivals"]').addClass('current');
        $('.flights #arrivals').addClass('current');
    }

    if (typeof $.cookie('userSavedFlight') !== 'undefined') {
        $('.flightSave').html('Replace Flight <i class="fa fa-angle-right"></i>');
        
        $('.saveflightList').each(function () {
            var flightNo = $(this).find('.flightNumber').text();
            if ($.cookie('userSavedFlight') === flightNo) {
                $(this).find('.flightSave').html('Saved <i class="fa fa-check"></i>');
            }
        });

        //Buttons on AB testing page
		$(".ab-flightSave").removeClass(saveButtonActiveClass);
        $('.ab-flightSave').html('Replace');

        $('.ab-saveflightList').each(function () {
            var flightNo = $(this).data('flightno');
            if ($.cookie('userSavedFlight') === flightNo) {
                $(".ab-flightSave[data-flightno=" + flightNo + "]").html('<i class="fa fa-check"></i> Saved');
				$(".ab-flightSave[data-flightno=" + flightNo + "]").addClass(saveButtonActiveClass);
            }
        });
    }

    //for the ab-testing flight listing widget
    //the html/functionality has changed slightly, cannot reuse the click function below
    $('.ab-saveflightList').on('click', function () {
        var $this = $(this);
        var $headerFlight = $('.ab-header-flight');
        $headerFlight.hide();

        var flightNo = $this.data("flightno");
        if (flightNo) {
            if (typeof $.cookie('userSavedFlight') !== 'undefined') {
                $.removeCookie('userSavedFlight');
            }

            $.cookie('userSavedFlight', flightNo, { path: '/;SameSite=Lax', secure: true });

            var arrivedDeparting;
            var fromTo;
            if ($this.hasClass('departures')) {
                arrivedDeparting = 'Depart';
                fromTo = 'To';
            } else {
                arrivedDeparting = 'Arrive';
                fromTo = 'From';
            }

			$('.ab-flightSave').removeClass(saveButtonActiveClass);
            $('.ab-flightSave').html('Replace');

            $(".ab-flightSave[data-flightno=" + flightNo + "]").html('<i class="fa fa-check"></i> Saved');
			$(".ab-flightSave[data-flightno=" + flightNo + "]").addClass(saveButtonActiveClass);

            var airlineImage;
            var $airlineLogo = $this.data("airlinelogo");
            if (typeof $airlineLogo === 'undefined') {
                airlineImage = '<span class="icon">V</span>';
            } else {
                airlineImage = '<img src="' + $airlineLogo + '" alt="' + $this.data("airlinelogoalt") + '" />';
            }

            var template = $('#AB-header-flight-info-template').html();
            Mustache.parse(template);

            var $status = $this.data('flightstatus');
            var flightInfo = {
                'flightNumber': $.cookie('userSavedFlight'),
                'airlineLogo': airlineImage,
                'fromTo': fromTo,
                'airport': $this.data('flightorgdest'),
                'departingArriving': arrivedDeparting,
                'scheduledTime': $this.data('flighttime'),
                'status': $status,
                'statusCssClass': $this.data('flightstatusclass'),
                'detailsUrl': $this.data('detailsurl')

            };
            
            $('.ab-header-flight-placeholder').show();
			$('.ab-header-flight').addClass('fadeInUp');

            var rendered = Mustache.render(template, flightInfo);
			$('#ab-header-flight-info').html(rendered);

			// setup clone
			$('.ab-header-flight-placeholder.fixed').remove();
			var $abHeaderFlightPlaceholder = $('.ab-header-flight-placeholder');
			var $abHeaderFlightPlaceholderClone = $abHeaderFlightPlaceholder.clone().insertAfter($abHeaderFlightPlaceholder);
			$abHeaderFlightPlaceholderClone.addClass('fixed');

			$(window).on('scroll', function() {
				var scrollTop = $(window).scrollTop();
				$abHeaderFlightPlaceholderClone.toggle($abHeaderFlightPlaceholder.offset().top < scrollTop);
			});

			setTimeout(function() {
				$headerFlight.show();
				$abHeaderFlightPlaceholderClone.find('.ab-header-flight').show();
			}, 0);
        }
    });

    $('.saveflightList').on('click', function () {
        var $this = $(this);
        ShowFlightSavedMessage();
        var $headerFlight = $('.header-flight');
        $headerFlight.hide();

        var flightNo = $this.find('.flightNumber').text();
        if (flightNo) {
            if (typeof $.cookie('userSavedFlight') !== 'undefined') {
                $.removeCookie('userSavedFlight');
            }

            $.cookie('userSavedFlight', flightNo, { path: '/;SameSite=Lax', secure: true });

            var arrivedDeparting;
            var fromTo;
            if ($this.hasClass('departures')) {
                arrivedDeparting = 'Depart';
                fromTo = 'To';
            } else {
                arrivedDeparting = 'Arrive';
                fromTo = 'From';
            }

            $('.flightSave').html('Replace Flight <i class="fa fa-angle-right"></i>');
            $this.find('.flightSave').html('Saved <i class="fa fa-check"></i>');

            var airlineImage;
            var $airlineLogo = $this.find('img');
            if (typeof $airlineLogo.attr('src') === 'undefined') {
                airlineImage = '<span class="icon">V</span>';
            } else {
                airlineImage = '<img src="' + $this.find('img').attr('src') + '" alt="' + $airlineLogo.attr('alt') + '" />';
            }

            var template = $('#header-flight-info-template').html();
            Mustache.parse(template);

            var $status = $this.find('.flightStatus');
            var flightInfo = {
                'flightNumber': $.cookie('userSavedFlight'),
                'airlineLogo': airlineImage,
                'fromTo': fromTo,
                'airport': $this.find('.flightOrgDest').text(),
                'departingArriving': arrivedDeparting,
                'scheduledTime': $this.find('.flightTime').text(),
                'status': $status.text(),
                'statusCssClass': $status.attr('class')
            };

            $('.header-flight-placeholder').show();
            $('.header-flight').addClass('fadeInUp');
            var rendered = Mustache.render(template, flightInfo);
            $('#header-flight-info').html(rendered);
            setTimeout(function () { $headerFlight.show(); }, 0);
        }
    });

    function tabClick(evt, tab) {
        //retailListing--sections__selected
        var i, tabcontent, tablinks;
        tabcontent = document.getElementsByClassName("js--tab");
        for (i = 0; i < tabcontent.length; i++) {
            tabcontent[i].style.display = "none";

            //display the right one
            if (tabcontent[i].classList.contains(tab))
                tabcontent[i].style.display = "block";
        }
        tablinks = document.getElementsByClassName("js--tab-link");
        for (i = 0; i < tablinks.length; i++) {
            tablinks[i].className = tablinks[i].className.replace(" retailListing--sections__selected", "");

            //display the right one
            if (tablinks[i].classList.contains(tab))
                tablinks[i].className += " retailListing--sections__selected";
        }

        const event = new Event('tab-switch');
        document.dispatchEvent(event);
    }

    function getEarlierFlights(evt, tab) {
        //tab = departures or arrivals
        var i, firstActiveIndex = 0, flightItems = document.querySelectorAll(".js--tab." + tab + " .flightListing__table__items__item:not(.flightListing__table__items__date)");
        var flightItemsMob = document.querySelectorAll(".js--tab." + tab + " .flightListing__table__items__item--mobile");

        //get first active item
        for (i = 0; i < flightItems.length; i++) {
            if (flightItems[i].classList.contains("active")) {
                firstActiveIndex = i;
                break;
            }
        }

        //get 5 earlier flights before the first active one
        var earliestFlightIndex = firstActiveIndex - 5;
        if (earliestFlightIndex < 0) {
            earliestFlightIndex = 0;

            //grey out the 'see later flights' link
            $(".flightListing__moreFlights--earlier[data-tab=" + tab + "]").addClass("disabled");
        }

        for (i = earliestFlightIndex; i < firstActiveIndex; i++) {
            if (flightItems[i]) {
                flightItems[i].classList.add("active");
				$(flightItems[i]).prev(".flightListing__table__items__date").addClass("active");
			}
			
            if (flightItemsMob[i])
                flightItemsMob[i].classList.add("active");
        }
    }

    function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
        return '';
    };

    function getLaterFlights(evt, tab) {
        //tab = departures or arrivals
        var i, lastActiveIndex = 0, flightItems = document.querySelectorAll(".js--tab." + tab + " .flightListing__table__items__item:not(.flightListing__table__items__date)");
        var flightItemsMob = document.querySelectorAll(".js--tab." + tab + " .flightListing__table__items__item--mobile");

        //get last active item
        for (i = flightItems.length - 1; i >= 0; i--) {
            if (flightItems[i].classList.contains("active")) {
                lastActiveIndex = i;
                break;
            }
        }

        var latestFlightIndex = lastActiveIndex + 5;
        if (latestFlightIndex > flightItems.length) {
            latestFlightIndex = flightItems.length;

            //grey out the 'see later flights' link
            $(".flightListing__moreFlights--later[data-tab=" + tab + "]").addClass("disabled");
        }

        for (i = lastActiveIndex; i < latestFlightIndex; i++) {
            if (flightItems[i]) {
		        flightItems[i].classList.add("active");
		        $(flightItems[i]).prev(".flightListing__table__items__date").addClass("active");
	        }

            if (flightItemsMob[i])
                flightItemsMob[i].classList.add("active");
        }
    }

    $(".js--tab-link.departures, .js--tab-link.arrivals").on("click", function (evt) {
        tabClick(evt, $(this).data("tab"));
    });

    $(".flightListing__moreFlights--earlier").on("click", function (evt) {
        getEarlierFlights(evt, $(this).data("tab"));
    });

    $(".flightListing__moreFlights--later").on("click", function (evt) {
        getLaterFlights(evt, $(this).data("tab"));
    });

    window.addEventListener('load', function () {
        if (getUrlParameter('listmode') === 'arrivals') {
            $("#arrivalsOpenOnLoad").trigger("click");
        } else {
            $("#departuresOpenOnLoad").trigger("click");
        }
    }, false);
});